{
  "panel": {
    "title": "Note",
    "newNote_title": "Nuova nota",
    "search_placeholder": "Cerca tra le note…",
    "search_aria": "Cerca tra le note",
    "clearSearch_aria": "Cancella ricerca",
    "editorPlaceholder": "A cosa stai pensando…",
    "titleInput_placeholder": "Nessun titolo",
    "untitled": "Senza titolo",
    "emptyNote": "Nota vuota",
    "loadingNotes": "Caricamento note…",
    "noNotesYet": "Nessuna nota ancora. Tocca + per crearne una.",
    "noResults": "Nessun risultato per \"{{query}}\"",
    "noNotesTagged": "Nessuna nota con il tag {{tag}}",
    "tagFilterAll": "Tutte",
    "filterByTag_aria": "Filtra per tag",
    "templates": "Modelli",
    "editorTheme_aria": "Tema dell'editor",
    "themeActive_aria": "Tema {{theme}} (attivo)",
    "theme_aria": "Tema {{theme}}",
    "themeName": {
      "dark": "Scuro",
      "sepia": "Seppia",
      "light": "Chiaro",
      "forest": "Foresta"
    },
    "voice": "Voce",
    "voice_title": "Nota vocale",
    "voiceUnavailable_title": "Riconoscimento vocale non disponibile in questo browser",
    "openVoiceRecorder_aria": "Apri il registratore di note vocali",
    "summarizing_title": "Riassunto in corso…",
    "summarize_title": "Riassumi",
    "summarizeNote_aria": "Riassumi nota",
    "aiCommands_title": "Comandi AI  Cmd+K",
    "openAiPalette_aria": "Apri la palette dei comandi AI",
    "enterFocusMode_title": "Modalità focus  Cmd+Shift+F",
    "exitFocusMode_title": "Esci dalla modalità focus  Cmd+Shift+F",
    "enterFocusMode_aria": "Entra in modalità focus",
    "exitFocusMode_aria": "Esci dalla modalità focus",
    "export_title": "Esporta nota",
    "delete_title": "Elimina nota",
    "delete_aria": "Elimina nota",
    "moreActions_title": "Altre azioni",
    "wordCount_one": "{{formatted}} parola · ~{{minutes}} min di lettura",
    "wordCount_other": "{{formatted}} parole · ~{{minutes}} min di lettura",
    "referencedBy_one": "Citata da {{count}}",
    "referencedBy_other": "Citata da {{count}}",
    "noMatchingNotes": "Nessuna nota corrispondente",
    "mobileTabs_aria": "Vista note",
    "mobileTabNotes": "Note",
    "mobileTabEditor": "Editor",
    "saveFailed": "Salvataggio della nota non riuscito: {{message}}",
    "deleteFailed": "Eliminazione della nota non riuscita",
    "loadFailed": "Caricamento delle note non riuscito",
    "analyzeFailed": "Analisi della nota non riuscita",
    "aiCommandFailed": "Comando AI non riuscito",
    "unknownError": "Errore sconosciuto"
  },
  "paywall": {
    "title": "Le Note fanno parte di Rhemn Pro",
    "safariBody": "Sblocca note sincronizzate, dettatura e riassunti IA con Rhemn Pro. Già membro? Si sblocca automaticamente all'accesso.",
    "body": "Sblocca note sincronizzate, dettatura dal browser e riassunti AI strutturati."
  },
  "format": {
    "bold": "Grassetto",
    "italic": "Corsivo",
    "strikethrough": "Barrato",
    "inlineCode": "Codice inline",
    "heading1": "Titolo 1",
    "heading2": "Titolo 2",
    "heading3": "Titolo 3",
    "bulletList": "Elenco puntato",
    "numberedList": "Elenco numerato",
    "blockquote": "Citazione",
    "codeBlock": "Blocco di codice",
    "toggleBold_aria": "Attiva/disattiva grassetto",
    "toggleItalic_aria": "Attiva/disattiva corsivo",
    "toggleStrikethrough_aria": "Attiva/disattiva barrato",
    "toggleInlineCode_aria": "Attiva/disattiva codice inline",
    "toggleBulletList_aria": "Attiva/disattiva elenco puntato",
    "toggleNumberedList_aria": "Attiva/disattiva elenco numerato",
    "toggleBlockquote_aria": "Attiva/disattiva citazione",
    "formatOptions_aria": "Opzioni di formattazione"
  },
  "analysis": {
    "heading": "Riassunto",
    "onDevice": "⚡ Sul dispositivo",
    "onDevice_aria": "Elaborato sul dispositivo",
    "applyToNote_title": "Applica alla nota",
    "applyToNote_aria": "Applica il riassunto alla nota",
    "summaryLabel": "Riassunto",
    "keyPointsLabel": "Punti chiave",
    "noKeyPoints": "Nessun punto chiave restituito per questa nota."
  },
  "export": {
    "markdown": "Esporta come Markdown",
    "plainText": "Esporta come testo semplice",
    "pdf": "Esporta come PDF",
    "allZip": "Esporta tutto come ZIP",
    "label": "Esporta"
  },
  "cmdk": {
    "dialog_aria": "Palette dei comandi AI",
    "input_placeholder": "Chiedi all'AI o esegui un comando…",
    "esc": "Esc",
    "back_aria": "Indietro",
    "translateTo": "Traduci in",
    "language_placeholder": "Lingua…",
    "aiActions": "Azioni AI",
    "noCommandsMatch": "Nessun comando corrisponde a \"{{query}}\"",
    "continue": {
      "label": "Continua a scrivere",
      "description": "Continua da dove hai lasciato"
    },
    "summarize": {
      "label": "Riassumi la selezione",
      "description": "Condensa nei punti chiave"
    },
    "formal": {
      "label": "Rendilo formale",
      "description": "Eleva il tono a professionale"
    },
    "simplify": {
      "label": "Semplifica",
      "description": "Linguaggio più breve e chiaro"
    },
    "translate": {
      "label": "Traduci in…",
      "description": "Traduci in un'altra lingua"
    },
    "expand": {
      "label": "Espandi questo punto",
      "description": "Trasforma il punto selezionato in prosa"
    },
    "languages": {
      "Spanish": "Spagnolo",
      "Arabic": "Arabo",
      "French": "Francese",
      "German": "Tedesco",
      "Japanese": "Giapponese",
      "Portuguese": "Portoghese"
    }
  },
  "templates": {
    "dialog_aria": "Scegli modello",
    "header": "Scegli un modello",
    "builtInLabel": "Integrati",
    "myTemplatesLabel": "I miei modelli",
    "saveCurrent": "Salva la nota corrente come modello",
    "myTemplatesEmpty": "I tuoi modelli salvati appariranno qui",
    "useTemplate": "Usa modello",
    "meeting": {
      "name": "Note di riunione",
      "description": "Registra decisioni e azioni da intraprendere",
      "structure": "Partecipanti / Ordine del giorno / Note / Azioni"
    },
    "journal": {
      "name": "Diario quotidiano",
      "description": "Rifletti sulla tua giornata",
      "structure": "Gratitudine / Successi di oggi / Note"
    },
    "book": {
      "name": "Riassunto di un libro",
      "description": "Registra le idee chiave di un libro",
      "structure": "Idea centrale / Citazioni chiave / Spunti"
    },
    "project": {
      "name": "Brief di progetto",
      "description": "Definisci ambito, obiettivi e parti interessate",
      "structure": "Obiettivo / Ambito / Rischi / Tempistiche"
    },
    "brainstorm": {
      "name": "Brainstorming",
      "description": "Raccolta libera di idee",
      "structure": "Argomento / Idee / Prossimi passi"
    },
    "weekly": {
      "name": "Revisione settimanale",
      "description": "Rivedi e pianifica la tua settimana",
      "structure": "Successi / Difficoltà / Aree di focus"
    }
  },
  "voice": {
    "dialog_aria": "Registratore di note vocali",
    "cancel_aria": "Annulla",
    "statusRecording": "Registrazione",
    "statusTranscribing": "Trascrizione…",
    "statusReview": "Revisione",
    "skip": "Salta",
    "mark": "Segna",
    "mark_title": "Inserisci un indicatore temporale",
    "captureMeeting": "Cattura riunione",
    "captureMeeting_title": "Cattura anche l'audio da una scheda di riunione",
    "meeting": "Riunione",
    "meeting_title": "Cattura della scheda della riunione",
    "markers_aria": "Indicatori temporali",
    "listening": "In ascolto…",
    "micDenied": "L'accesso al microfono è disattivato. Consentilo nelle Impostazioni e riprova.",
    "captureFailed": "Impossibile avviare la registrazione. Riprova tra un istante.",
    "tabPicker_aria": "Scegli una scheda di riunione da catturare",
    "captureFrom": "Cattura audio da…",
    "noAudibleTab": "Nessuna scheda sta riproducendo audio. Apri la tua riunione e assicurati che qualcuno stia parlando, poi riprova.",
    "tabPickerCancel": "Annulla",
    "tabTranscript": "Trascrizione",
    "structuring": "Strutturazione…",
    "structuredNote": "Nota strutturata",
    "structureFailed": "Impossibile creare la nota strutturata.",
    "retryStructure": "Riprova",
    "browserTranscript": "Trascrizione del browser",
    "nothingCaptured": "Niente è stato catturato.",
    "buildingStructured": "Creazione della nota strutturata…",
    "cancel": "Annulla",
    "stop": "Stop",
    "recordAgain": "Registra di nuovo",
    "saveToNote": "Salva nella nota",
    "statusMeeting": "Riunione",
    "captureStrip_aria": "Acquisizione audio da {{tab}}",
    "stopCapture": "Interrompi acquisizione",
    "stopCapture_title": "Interrompe l'acquisizione della scheda — il microfono continua a registrare",
    "stopsIn": "Si ferma tra {{time}}",
    "autoStopped": "Registrazione interrotta al limite di 60 minuti.",
    "autoStoppedQuota": "Registrazione interrotta — hai usato i minuti di trascrizione di questo mese.",
    "captureLost": "La scheda della riunione si è chiusa. Il microfono sta ancora registrando.",
    "tabSummary": "Riepilogo",
    "noSpeakers": "Interlocutori non identificati",
    "speakerN": "Interlocutore {{number}}",
    "renameSpeaker_aria": "Rinomina {{name}} — si applica a tutte le sue battute",
    "renameSpeaker_input_aria": "Nome dell'interlocutore",
    "turnTime_title": "Detto a {{time}}",
    "actionItemsTitle": "Azioni da fare",
    "actionsCount": "{{checked}} di {{total}}",
    "addToTasks_one": "Aggiungi {{count}} alle Attività",
    "addToTasks_other": "Aggiungi {{count}} alle Attività",
    "addToTasksZero": "Aggiungi alle Attività",
    "adding": "Aggiunta…",
    "tasksAdded_one": "{{count}} attività aggiunta",
    "tasksAdded_other": "{{count}} attività aggiunte",
    "viewTasks": "Vedi",
    "addFailed": "Impossibile aggiungere — riprova.",
    "minutesLeft_one": "{{count}} min rimasto",
    "minutesLeft_other": "{{count}} min rimasti",
    "minutesLeftShort_one": "{{count}} min rimasto",
    "minutesLeftShort_other": "{{count}} min rimasti",
    "minutesLeft_title": "{{count}} minuti di trascrizione rimasti questo mese",
    "quotaExhausted": "Hai usato i minuti riunione di questo mese. Si rinnovano il {{date}}.",
    "quotaUnknown": "Minuti rimanenti sconosciuti — la registrazione può raggiungere il limite mensile",
    "meetingProRequired": "La trascrizione delle riunioni fa parte di Pro. La tua trascrizione dal vivo è conservata qui sotto.",
    "gateTitle": "Registrazione riunioni",
    "gateBody": "Registra la scheda di una riunione insieme al microfono — con interlocutori identificati e azioni estratte. Incluso con Pro.",
    "gateLater": "Non ora",
    "gateCta": "Scopri Pro",
    "roomOption": "Nessuna scheda — registra la stanza",
    "roomHint": "Una chiamata in vivavoce, un'app nativa o persone nella stanza — tutto ciò che puoi sentire ad alta voce.",
    "roomHint_title": "Se l'altra parte è nelle tue cuffie, il microfono non può sentirla — usa l'altoparlante.",
    "recordRoom": "Registra la stanza",
    "recordRoom_title": "Registra tutti quelli che il microfono sente — con interlocutori identificati",
    "roomStart": "Avvia",
    "statusRoom": "Stanza",
    "roomStrip": "Registrazione della stanza",
    "roomStrip_aria": "Registrazione della stanza — tutti quelli che il microfono sente",
    "roomOff": "Disattiva",
    "roomOff_title": "Disattiva la modalità stanza — questa torna a essere una normale nota vocale",
    "roomRenameHint": "Tocca un nome per rinominarlo — uno di questi sei tu.",
    "gateBodyRoom": "Registra ciò che viene detto intorno a te — con interlocutori identificati e azioni estratte. Incluso con Pro.",
    "roomHintDevice": "Le chiamate su questo dispositivo non possono essere registrate — iOS le mantiene private. Un altro telefono in vivavoce, o una conversazione nella stanza, funziona.",
    "autoStoppedSize": "Registrazione interrotta al limite di dimensione del caricamento.",
    "tooLarge": "La registrazione era troppo grande per essere caricata, quindi non è stato possibile trascriverla.",
    "destTo": "In",
    "dest_aria": "Aggiungi alla lista: {{name}}",
    "destMenu_aria": "Scegli una lista",
    "destNewPending_aria": "Nuova lista: {{name}}"
  },
  "meetingNotice": {
    "title": "Le riunioni, nelle tue note",
    "body": "Rhemn ora può registrare una scheda riunione che scegli tu — solo mentre registri una nota vocale, e solo la scheda che selezioni.",
    "factPrivacy": "L'audio viene elaborato per creare la trascrizione, poi eliminato. Le registrazioni non vengono mai conservate.",
    "factControl": "Non viene acquisito nulla finché non premi registra e scegli una scheda.",
    "cta": "Ho capito",
    "privacyLink": "Leggi la nostra informativa sulla privacy",
    "dialog_aria": "Informazioni sul nuovo permesso di registrazione riunioni"
  }
}
